import {
    CHANGE_LOCALE,
} from 'store/actions/types';

export const DEFAULT_LOCALE = 'en';

export default (initialLocale = DEFAULT_LOCALE) => {
    return (previousLocale = initialLocale, action) => {
        switch (action.type) {
            case CHANGE_LOCALE:
                return action.payload;
            default:
                return previousLocale;
        }
    };
};



// WEBPACK FOOTER //
// ./src/store/reducers/localeReducer.js